var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgJciLogo = function SvgJciLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#32C89C",
    d: "M4.69 28.037c.23.235.467.47.713.694 2.598-1.228 4.743-2.762 6.375-4.577a42 42 0 0 1-.424-4.351c-.224-5.154.529-9.468 2.017-12.962-1.098-1.883-2.634-3.57-4.615-4.972-.563.3-1.106.638-1.627 1.001 3.008 3.517 4.485 7.86 4.225 12.514-.278 5.012-2.765 9.436-6.664 12.655"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00AAB8",
    d: "M8.52 30.972q.44.247.898.465a23 23 0 0 0 3.52-1.996q-.33-1.129-.6-2.3c-1.206 1.37-2.513 2.649-3.817 3.831M13.315.236a16 16 0 0 0-2.038.541 33 33 0 0 1 3.104 4.005c.473-.836.99-1.622 1.556-2.343a22 22 0 0 0-2.62-2.203"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#75E600",
    d: "M.44 20.273c1.686-1.452 2.846-3.315 3.234-5.465.416-2.303-.15-4.598-1.437-6.645A16.553 16.553 0 0 0 .44 20.27"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#52D65A",
    d: "M5.518 15.109C5.184 18.277 4 21.593 1.865 24.122c.167.315.334.627.518.93 4.083-2.234 6.726-5.774 7.11-10.116.343-3.835-1.443-7.687-4.388-10.42-.453.433-.886.893-1.288 1.378 1.424 2.722 2.057 5.828 1.698 9.212"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#00ADFF",
    d: "M27.989 28.402A16.53 16.53 0 0 0 33 17.633c-2.75 2.643-4.473 6.878-5.011 10.77"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#0087FF",
    d: "M24.735 30.853q.383-.221.753-.463c1.576-7.45 4.179-12.394 7.399-16.18a16.4 16.4 0 0 0-.527-2.449c-6.75 4.164-8.174 13.445-7.625 19.089"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#152EA9",
    d: "M11.297 19.8c.204 4.742 1.197 9.176 2.77 13.064q.474.068.96.11C13.55 20.425 14.987 8.317 22.313.97A16.5 16.5 0 0 0 18.156 0c-4.504 3.968-7.26 10.554-6.859 19.8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#004FC1",
    d: "M17.73 32.997q.474-.035.937-.093c-.294-8.175 1.078-21.735 9.134-28.516a16.6 16.6 0 0 0-2.425-1.884C14.94 9.614 14.992 23.524 17.73 33"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#006DF8",
    d: "M21.385 32.313q.417-.126.82-.275c.476-8.412 2.728-17.366 9.03-23.095a17 17 0 0 0-1.424-2.3c-8.545 5.17-10.293 17.425-8.426 25.668"
  })));
};
export default SvgJciLogo;